import { render, staticRenderFns } from "./TaxonomiesBreadcrumbs.vue?vue&type=template&id=74ab11ec&scoped=true&"
import script from "./TaxonomiesBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./TaxonomiesBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./TaxonomiesBreadcrumbs.vue?vue&type=style&index=0&id=74ab11ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ab11ec",
  null
  
)

export default component.exports